import React from 'react';
import { Button } from 'reactstrap';
import Layout from '../components/layout';
import lavenderbottle from "../images/lavenderbottle.png";
import icongreet from "../images/icongreet.svg";
import icontreat from "../images/icontreat.svg";
import iconcomplete from "../images/iconcomplete.svg";

const Visit = () => (
    <Layout>
        <main className='visit mt-5'>
            {/* contact and map Section */}
            <section className='contact'>
                <div className="container">
                    <div className='row my-5 justify-content-center align-items-center'>
                        <div className='col-md-6 col-lg-4 address'>
                            <h4>find your <br />organic experience</h4>
                            <div className="mt-4">241 S Beverly Drive</div>
                            <div>Beverly Hills, CA - 90212</div>
                            <div>info@thefacex.com</div>
                        </div>

                        <div className='col-md-6 col-lg-8 map-cntr'>
                            <iframe 
                            className='map' 
                            src="https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=en&amp;q=241%20S%20Beverly%20Drive%20Beverly%20Hills%2C%20CA%20-%2090212+(My%20Business%20Name)&amp;ie=UTF8&amp;t=&amp;z=14&amp;iwloc=B&amp;output=embed" 
                            title="map"
                            frameborder="0" 
                            allowFullScreen>
                            </iframe>
                        </div>
                    </div>
                </div>
            </section>

            <div className='text-center'>
                <div className="display-1">what to expect</div>
                <p className='mb-5'>First time visit?  Here's what to expect.</p>
            </div>

            {/* Greet Section */}
            <section className='greet bg-light text-teal'>
                <div className='row'>
                    <div className='col-md-6 image-sec text-gray'></div>
                    <div className='col-md-5 content'>
                        <h4 className="d-flex align-items-center">
                            <img src={icongreet} alt='icongreet' />
                            <span className='pl-4'>Greet</span>
                        </h4>
                        <p className='font-small line-height-24 mt-4'>
                            Enjoy a complimentary juice shot, made with activating ingredients like apple cider vinegar, tumeric, ginger, chia seeds, etc.  <br />Our estheticians will review your history and sensitivities before making a treatment mask that's suitable for you, using fresh organic ingredients, oils and essences specially selected for their healing properties.
                        </p>
                    </div>
                    <div className='col-md-1'></div>
                </div>
            </section>

            {/* treat Section */}
            <section className='treat text-teal'>
                <div className='treat-box row my-5 justify-content-center align-items-center'>
                    <div className='offset-md-2 col-md-4 treat-box-content'>
                        <h4 className="d-flex align-items-center">
                            <img src={icontreat} alt='icontreat' />
                            <span className='pl-4'>Treat</span>
                        </h4>

                        <p className='font-small text-black mt-3 line-height-24'>
                            Our FaceX facials are performed in private treatment rooms.  Put on your favorite music, dim the lights and add a hint of lavender or citrus aroma to your faceX facial.  <br />Lay back and relax as our trained FaceX esthetician performs your custom FaceX facial.
                        </p>
                    </div>

                    <div className='col-md-5 private'>
                        <img src={lavenderbottle} alt='lavenderbottle' />
                    </div>
                    <div className='col-md-1'></div>
                </div>
            </section>

            {/* complete Section */}
            <section className='complete mb-5 bg-light'>
                <div className='row'>
                    <div className='col-md-5 image-sec'></div>
                    <div className='col-md-6 content d-flex align-items-center'>
                        <div>
                            <h4 className="d-flex align-items-center">
                                <img src={iconcomplete} alt='iconcomplete' />
                                <span className='pl-4 title text-red'>complete</span>
                            </h4>

                            <div className='font-small mt-3'>
                                At the end of each visit, we curate a selection of all natural and organic skin products for recommended usage in your daily regimen.
                            </div>

                            <div  className='font-small mt-2'>
                                Join Our loyalty program for spcial offers, discount services, and a frequent-use card.
                            </div>

                            <div  className='font-small mt-2'>
                                Download our app to easily book, reschedule, get reminders for your appointments, and view your aftercare recommendations.
                            </div>
                        </div>
                    </div>
                    <div className='col-md-1'></div>
                </div>
            </section>

            {/* look good Section */}
            <section className='mt-5 mb-5'>
                <div className='d-flex flex-column align-items-center experience'>
                    <h1 className='text-uppercase'>experience the freshness</h1>
                    <div>
                        <Button className='btn-outline-primary btn-lg mt-5'>BOOK YOUR ORGANIC FACIALS</Button>
                    </div>
                </div>
            </section>
        </main>
    </Layout>
)

export default Visit
